/**
 * DMS-specific permission constants.
 *
 * Well-known feature IDs and their corresponding permission checks
 * for DMS admin pages. These are DMS-only and should not be imported
 * by platform code.
 */
import {
  createResourcePermissionCheck,
  RESOURCE_PERMISSIONS,
  RESOURCE_TYPES,
} from '@/types/permissions';

/** Well-known feature IDs for DMS permission-gated admin pages */
export const FEATURE_IDS = {
  DOCUMENT_TYPES: '00000001-0000-4000-8000-000000000001',
  PDF_GENERATION: '00000001-0000-4000-8000-000000000002',
  PURCHASING_SETTINGS: '00000001-0000-4000-8000-000000000003',
  ATE_TOKENS: '00000001-0000-4000-8000-000000000004',
  PURCHASING: '00000001-0000-4000-8000-000000000005',
  TESTING: '00000001-0000-4000-8000-000000000006',
  CAPAS: '00000001-0000-4000-8000-000000000007',
  CAPA_SETTINGS: '00000001-0000-4000-8000-000000000009',
  ECRS: '00000001-0000-4000-8000-00000000000a',
  CALIBRATION: '00000001-0000-4000-8000-00000000000b',
} as const;

/** Feature-level permission checks for DMS admin pages */
export const FEATURE_CHECKS = {
  DOCUMENT_TYPES: createResourcePermissionCheck(
    RESOURCE_TYPES.FEATURE,
    RESOURCE_PERMISSIONS.READ,
    FEATURE_IDS.DOCUMENT_TYPES
  ),
  PDF_GENERATION: createResourcePermissionCheck(
    RESOURCE_TYPES.FEATURE,
    RESOURCE_PERMISSIONS.READ,
    FEATURE_IDS.PDF_GENERATION
  ),
  PURCHASING_SETTINGS: createResourcePermissionCheck(
    RESOURCE_TYPES.FEATURE,
    RESOURCE_PERMISSIONS.READ,
    FEATURE_IDS.PURCHASING_SETTINGS
  ),
  ATE_TOKENS: createResourcePermissionCheck(
    RESOURCE_TYPES.FEATURE,
    RESOURCE_PERMISSIONS.READ,
    FEATURE_IDS.ATE_TOKENS
  ),
  PURCHASING: createResourcePermissionCheck(
    RESOURCE_TYPES.FEATURE,
    RESOURCE_PERMISSIONS.READ,
    FEATURE_IDS.PURCHASING
  ),
  TESTING: createResourcePermissionCheck(
    RESOURCE_TYPES.FEATURE,
    RESOURCE_PERMISSIONS.READ,
    FEATURE_IDS.TESTING
  ),
  CAPAS: createResourcePermissionCheck(
    RESOURCE_TYPES.FEATURE,
    RESOURCE_PERMISSIONS.READ,
    FEATURE_IDS.CAPAS
  ),
  CAPA_SETTINGS: createResourcePermissionCheck(
    RESOURCE_TYPES.FEATURE,
    RESOURCE_PERMISSIONS.READ,
    FEATURE_IDS.CAPA_SETTINGS
  ),
  ECRS: createResourcePermissionCheck(
    RESOURCE_TYPES.FEATURE,
    RESOURCE_PERMISSIONS.READ,
    FEATURE_IDS.ECRS
  ),
  CALIBRATION: createResourcePermissionCheck(
    RESOURCE_TYPES.FEATURE,
    RESOURCE_PERMISSIONS.READ,
    FEATURE_IDS.CALIBRATION
  ),
} as const;
